export enum EPaymentMethod {
  BANK_CARD = 'BANK_CARD',
  SBP = 'SBP',
  QWIK = 'QWIK',
  UPI = 'UPI',
  IMPS = 'IMPS',
  THAI_QR = 'THAI_QR',
  P2P = 'P2P',
}
